import React from 'react'

function AssignModules() {
  return (
    <>
      <div className="" id='main-assignmodules'>
        <div className="row">
          <div className="col-12 mb-4">
            <h1 className='fw-bold mb-3'>Assign modules</h1>
            <span style={{ color: "rgba(185, 187, 189, 1)" }}>Select the modules and sub-modules for the client.</span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-4">
            <div className="card p-3">
              <span className='fw-semibold mb-3' style={{ fontSize: "14px" }}>Modules</span>

              <div className="d-flex flex-column gap-4">
                <div className='d-flex align-items-center gap-3'>
                  <input type="checkbox" name="" id="" />
                  <span>1. Maintenance</span>
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <input type="checkbox" name="" id="" />
                  <span>2. Patient Portal</span>
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <input type="checkbox" name="" id="" />
                  <span>3. Appointment Schedule</span>
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <input type="checkbox" name="" id="" />
                  <span>4. Facility Management</span>
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <input type="checkbox" name="" id="" />
                  <span>5. Physician Management</span>
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <input type="checkbox" name="" id="" />
                  <span>6. Pharmacy Management</span>
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <input type="checkbox" name="" id="" />
                  <span>7. Laboratory Management</span>
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <input type="checkbox" name="" id="" />
                  <span>8. Bed Management</span>
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <input type="checkbox" name="" id="" />
                  <span>9. Physiotherapy</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-4">
            <div className="card p-3">
              <span className='fw-semibold mb-2 border-bottom pb-2' style={{ fontSize: "14px" }}>Sub-modules</span>

              <div className="d-flex flex-column gap-3">
                <div className='d-flex align-items-center gap-3 border-bottom pb-2'>
                  <input type="checkbox" name="" id="" />
                  <span>Level 1 </span>
                </div>

                <div className='d-flex align-items-center gap-3 border-bottom pb-2'>
                  <input type="checkbox" name="" id="" />
                  <span>Level 2</span>
                </div>

                <div className='d-flex align-items-center gap-3 border-bottom pb-2'>
                  <input type="checkbox" name="" id="" />
                  <span>Level 3</span>
                </div>

                <div className='d-flex align-items-center gap-3 '>
                  <input type="checkbox" name="" id="" />
                  <span>Level 4</span>
                </div>

                
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-4">
            <button className='rounded-5 border-0 btn btn-danger d-flex align-items-center justify-content-center' style={{width: '6rem'}}>   Add</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default AssignModules